import { ArrowRight } from "lucide-react";

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white">
      {/* CTA Banner */}
      <div className="border-b border-slate-800">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-16 text-center">
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-4" style={{ fontFamily: 'Outfit' }}>
            Pronto a fare il salto di qualita'?
          </h2>
          <p className="text-slate-400 text-base md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
            Partiamo da una chiacchierata senza impegno. Scopri come il digitale puo' diventare il motore di crescita del tuo business.
          </p>
          <button
            onClick={() => scrollTo("#contatti")}
            className="inline-flex items-center gap-2 bg-[#52B788] hover:bg-[#40916C] text-white rounded-full h-12 px-8 font-medium transition-all shadow-lg shadow-green-900/30 text-base"
            data-testid="footer-cta-button"
          >
            Prenota la Tua Call <ArrowRight size={18} />
          </button>
        </div>
      </div>

      {/* Footer links */}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_ai-agency-book/artifacts/uwykpigj_LOGO%20COLIBRI%20VERDE.png" 
              alt="Colibri Marketing Agency" 
              className="h-10 w-auto"
            />
            <p className="text-slate-400 text-sm mt-3 leading-relaxed">
              Colibri Marketing Agency di Antonio Borzi.
              <br />
              Il tuo ufficio marketing in affitto.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-slate-300" style={{ fontFamily: 'Outfit' }}>
              Servizi
            </h4>
            <ul className="space-y-2.5">
              {["Gestione Comunicazione", "Digital Strategy", "Digital Export", "Consulenza B2B"].map((s) => (
                <li key={s}>
                  <button onClick={() => scrollTo("#servizi")} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-slate-300" style={{ fontFamily: 'Outfit' }}>
              Link Utili
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://www.colibrimarketingagency.it" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  colibrimarketingagency.it
                </a>
              </li>
              <li>
                <a href="https://www.digitalstrategyborzi.com" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  digitalstrategyborzi.com
                </a>
              </li>
              <li>
                <a href="https://www.ilborzi.com" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  ilborzi.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} Colibri Marketing Agency - Digital Strategy di Antonio Borzi srl. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-slate-500">
            P.IVA: Digital Strategy di Antonio Borzi srl
          </p>
        </div>
      </div>
    </footer>
  );
}
